import { render } from "./Slack.vue?vue&type=template&id=3827a01d&scoped=true"
import script from "./Slack.vue?vue&type=script&lang=js"
export * from "./Slack.vue?vue&type=script&lang=js"

import "./Slack.vue?vue&type=style&index=0&id=3827a01d&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3827a01d"]])

export default __exports__